<div class="display-info-wrapper">
  <div
    class="display-info"
    [style.minHeight.px]="containerHeight"
    [ngClass]="{ 'display-info-border': border, 'black-placeholder': blackPlaceholder, 'allow-padding': editorPadding }"
    [ngStyle]="{ background: whiteBackground ? '#ffffff' : 'transparent' }"
  >
    <div class="display-info-editor">
      <quill-editor
        #editor
        [modules]="editorModules"
        [placeholder]="placeholder"
        class="editor-wrapper"
        [ngClass]="{ 'editor-headerless': !showMenuBar }"
        [ngModel]="initialMessage"
        (ngModelChange)="updateValue($event)"
        (onContentChanged)="onQuillContentChanged($event)"
        (onBlur)="cleanMessage()"
        (onEditorCreated)="onEditorCreated($event)"
      ></quill-editor>
      <!-- Image Input -->
      <div *ngIf="showImageInput" [style.top.px]="imageInputPositionTop" [style.left.px]="imageInputPositionLeft" class="image-url" data-mode="image">
        <label for="image-url">Image URL: </label>
        <input [(ngModel)]="imageURL" type="text" id="image-url" (keydown.enter)="addImageToEditor($event)" class="h-100" />
        <a (click)="addImageToEditor($event)" class="ql-action">Save</a>
      </div>
      <!-- /Image Input-->
      <!-- Image Size Modal-->
      <div *ngIf="showSizeModal" [style.top.px]="imageInputPositionTop" [style.left.px]="imageInputPositionLeft" class="image-url-modal">
        <span>Set Image Dimensions</span>
        <div class="d-flex flex-column">
          <div class="d-flex image-dimensions">
            <label>
              Width:
              <input [(ngModel)]="selectedImageWidth" class="h-100" (keydown.enter)="applyNewImageDimensions()" />
            </label>
            <label>
              Height:
              <input [(ngModel)]="selectedImageHeight" class="h-100" (keydown.enter)="applyNewImageDimensions()" />
            </label>
          </div>
          <div class="d-flex justify-content-center image-modal-btns">
            <button class="text-primary font-weight-bold" (keydown.enter)="applyNewImageDimensions()" (click)="applyNewImageDimensions()">Apply</button>
            <button class="text-secondary font-weight-bold" (keydown.enter)="closeImageDimensionsModal()" (click)="closeImageDimensionsModal()">Cancel</button>
          </div>
        </div>
      </div>
      <!-- /Image Size Modal-->

      @if (showFloatingToolbar) {
      <!-- Floating Toolbar -->
      <div
        class="tw-absolute tw-p-2 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-lg tw-z-[1000] tw-flex tw-flex-wrap tw-gap-2 tw-items-center tw-max-w-[400px] tw-animate-in tw-fade-in tw-slide-in-from-top-2 tw-duration-200 dark:tw-bg-black"
        [style.top.px]="floatingToolbarTop"
        [style.left.px]="floatingToolbarLeft"
      >
        <!-- Text Formatting -->
        <div class="tw-flex tw-gap-0.5 tw-items-center tw-border-r tw-border-gray-200 tw-pr-2 tw-mr-1 dark:tw-border-gray-600">
          <button
            class="tw-border-none tw-bg-transparent tw-cursor-pointer tw-rounded tw-p-1.5 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 tw-text-gray-700 tw-min-w-7 tw-min-h-7 hover:tw-bg-gray-100 hover:tw-text-black dark:tw-text-white dark:hover:tw-bg-gray-700 dark:hover:tw-text-white"
            [ngClass]="isFormatActive('bold') ? '!tw-bg-black !tw-text-white dark:!tw-bg-white dark:!tw-text-black' : ''"
            data-format="bold"
            (click)="applyFormat('bold')"
            title="Bold"
          >
            <span class="material-icons tw-text-base tw-text-inherit">format_bold</span>
          </button>
          <button
            class="tw-border-none tw-bg-transparent tw-cursor-pointer tw-rounded tw-p-1.5 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 tw-text-gray-700 tw-min-w-7 tw-min-h-7 hover:tw-bg-gray-100 hover:tw-text-black dark:tw-text-white dark:hover:tw-bg-gray-700 dark:hover:tw-text-white"
            [ngClass]="isFormatActive('italic') ? '!tw-bg-black !tw-text-white dark:!tw-bg-white dark:!tw-text-black' : ''"
            data-format="italic"
            (click)="applyFormat('italic')"
            title="Italic"
          >
            <span class="material-icons tw-text-base tw-text-inherit">format_italic</span>
          </button>
          <button
            class="tw-border-none tw-bg-transparent tw-cursor-pointer tw-rounded tw-p-1.5 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 tw-text-gray-700 tw-min-w-7 tw-min-h-7 hover:tw-bg-gray-100 hover:tw-text-black dark:tw-text-white dark:hover:tw-bg-gray-700 dark:hover:tw-text-white"
            [ngClass]="isFormatActive('strike') ? '!tw-bg-black !tw-text-white dark:!tw-bg-white dark:!tw-text-black' : ''"
            data-format="strike"
            (click)="applyFormat('strike')"
            title="Strikethrough"
          >
            <span class="material-icons tw-text-base tw-text-inherit">strikethrough_s</span>
          </button>
        </div>

        <!-- Lists -->
        <div class="tw-flex tw-gap-0.5 tw-items-center tw-border-r tw-border-gray-200 tw-pr-2 tw-mr-1 dark:tw-border-gray-600">
          <button
            class="tw-border-none tw-bg-transparent tw-cursor-pointer tw-rounded tw-p-1.5 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 tw-text-gray-700 tw-min-w-7 tw-min-h-7 hover:tw-bg-gray-100 hover:tw-text-black dark:tw-text-white dark:hover:tw-bg-gray-700 dark:hover:tw-text-white"
            data-format="list"
            value="ordered"
            (click)="toggleList('ordered')"
            [ngClass]="isListActive('ordered') ? '!tw-bg-black !tw-text-white dark:!tw-bg-white dark:!tw-text-black' : ''"
            title="Numbered List"
          >
            <span class="material-icons tw-text-base tw-text-inherit">format_list_numbered</span>
          </button>
          <button
            class="tw-border-none tw-bg-transparent tw-cursor-pointer tw-rounded tw-p-1.5 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 tw-text-gray-700 tw-min-w-7 tw-min-h-7 hover:tw-bg-gray-100 hover:tw-text-black dark:tw-text-white dark:hover:tw-bg-gray-700 dark:hover:tw-text-white"
            data-format="list"
            value="bullet"
            (click)="toggleList('bullet')"
            [ngClass]="isListActive('bullet') ? '!tw-bg-black !tw-text-white dark:!tw-bg-white dark:!tw-text-black' : ''"
            title="Bullet List"
          >
            <span class="material-icons tw-text-base tw-text-inherit">format_list_bulleted</span>
          </button>
        </div>

        <!-- Blockquote -->
        <div class="tw-flex tw-gap-0.5 tw-items-center">
          <button
            class="tw-border-none tw-bg-transparent tw-cursor-pointer tw-rounded tw-p-1.5 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 tw-text-gray-700 tw-min-w-7 tw-min-h-7 hover:tw-bg-gray-100 hover:tw-text-black dark:tw-text-white dark:hover:tw-bg-gray-700 dark:hover:tw-text-white"
            data-format="blockquote"
            (click)="applyFormat('blockquote')"
            [ngClass]="isFormatActive('blockquote') ? '!tw-bg-black !tw-text-white dark:!tw-bg-white dark:!tw-text-black' : ''"
            title="Blockquote"
          >
            <span class="material-icons tw-text-base tw-text-inherit">format_quote</span>
          </button>
        </div>
      </div>
      }
      <!-- /Floating Toolbar -->
    </div>
  </div>
</div>
